import { rem } from 'polished';
import * as React from 'react';
import styled, { css } from 'styled-components';
import { itemIsSkvelko } from '../../../utilities';
import { __ } from '@bart.sk-eshop/react-i18n';

const Sticker = css`
  text-align: center;
  color: ${({ theme }) => theme.color.white};
  border-radius: 50%;
  width: ${rem(60)};
  height: ${rem(60)};
  position: absolute;
  top: ${rem(10)};
  right: ${rem(10)};
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NotSkvelkoTextWrapper = styled.div`
  text-transform: uppercase;
  font-weight: 800;
  font-size: ${rem(14)};
  line-height: ${rem(15)};
`;

const Wrapper = styled.div`
  ${Sticker};
  background: ${({ theme }) => theme.color.primary};
`;

const SkvelkoTextWrapper = styled.div``;

const SvelkoTopTextWrapper = styled.div`
  font-size: 9px;
  line-height: 10px;
  font-weight: bold;
`;

const SkvelkoBottomText = styled.div`
  text-transform: uppercase;
  font-weight: 800;
  font-size: ${rem(12)};
  line-height: ${rem(12)};
  margin-top: ${rem(3)};
`;

interface SaleStickerProductPreviewProps {
  product: any;
  enableGoodPrice: boolean;
}

const SaleStickerProductPreview = (props: SaleStickerProductPreviewProps) => {
  const { product, enableGoodPrice } = props;

  const isSkvelko = itemIsSkvelko(product);
  return (
    <Wrapper>
      {isSkvelko && enableGoodPrice ? (
        <SkvelkoTextWrapper>
          {' '}
          <SvelkoTopTextWrapper>
            {' '}
            <div>{__('len')}</div> <div>{__('v eshope')}:</div>{' '}
          </SvelkoTopTextWrapper>{' '}
          <SkvelkoBottomText> {__('DOBRÁ CENA')} </SkvelkoBottomText>{' '}
        </SkvelkoTextWrapper>
      ) : (
        <NotSkvelkoTextWrapper
          style={{
            fontSize: product?.action_label_font_size
              ? product?.action_label_font_size / 2
              : undefined,
            lineHeight: product?.action_label_line_height
              ? product?.action_label_line_height / 2
              : undefined,
          }}
        >
          {' '}
          {product?.action_label_text
            ? product?.action_label_text
            : __('AKCIA')}{' '}
        </NotSkvelkoTextWrapper>
      )}
    </Wrapper>
  );
};

export default SaleStickerProductPreview;
